import { CommonAPIService } from "src/servicehandlers/CommonHandler";

export class FlightSchoolsAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  getAllFlightSchools(router) {
    const url = `/api/flightSchools`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  getFlightSchoolById(id, router) {
    const url = `/api/flightSchools/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  createFlightSchool(params, router) {
    const url = `/api/flightSchools`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  updateFlightSchool(id, params, router) {
    const url = `/api/flightSchools/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deleteFlightSchool(id, router) {
    const url = `/api/flightSchools/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }
}
export default FlightSchoolsAPIService;
